import { render } from "./CodeOfConduct.vue?vue&type=template&id=1463ab82"
import script from "./CodeOfConduct.vue?vue&type=script&lang=ts"
export * from "./CodeOfConduct.vue?vue&type=script&lang=ts"
script.render = render

export default script